import React from 'react';
import PropTypes from 'prop-types';
import HeaderContainer from '../../redux/containers/HeaderContainer';
import Footer from '../Footer/Footer';

const App = props => (
  <div>
    <div id="nit-alme-window-root" />
    <HeaderContainer />
    {props.children}
    <Footer />
  </div>
);
App.propTypes = { children: PropTypes.object };

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App/App.js
 **/